import { IdiomaService } from '../../providers/idioma/idioma.service';
import { Idioma } from '../../domain/Idioma';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DiagnosticoService } from '../../providers/diagnostico/diagnostico.service';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { IdiomaCalendario } from '../../domain/IdiomaCalendatio';
import { TranslateService } from 'ng2-translate/src/translate.service';
import { Predicate } from 'breeze-client';
import { BalizaFormulario } from '../../domain/BalizaFormulario';
import { Encuesta } from '../../domain/Encuesta';
import { BreadcrumbService } from '../../breadcrumb.service';
import { AppComponent } from '../../app.component';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { Exportar } from '../../service/exportar.service';
import { Permisos, PermisosService } from '../../providers/authentication/permisos.service';

@Component({
  templateUrl: './Encuestas.component.html',
  styles: [`
      .cars-datalist ul {
          margin: 0;
          padding: 0;
      }

      @media (max-width:640px) {
          .cars-datalist .text-column {
              text-align: center;
          }
      }
  `],
  styleUrls: ['./Encuestas.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [Exportar]
})

export class EncuestasComponent implements OnInit {

	public displayDialog: boolean = true;
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;
	spinner: HTMLElement;

	cols_balizas: any[] = [];

	encuestas: any[] = [];
	encuestasFiltradas: any[] = [];

	cols_encuestas: any[] = [];


	idiomaCalendario: IdiomaCalendario ;

	fecha_DesdeFilter: Date;
	fecha_HastaFilter: Date;
	public permisos: Permisos = new Permisos();



	displayDialogEncuesta: boolean = false;
	encuestaSeleccionada: Encuesta = new Encuesta();


	constructor(
		private appComponent: AppComponent,
		private translate: TranslateService,
		private breadcrumbService: BreadcrumbService,
		public DIAG: DiagnosticoService,
		public authService: AuthenticationService,
		private entityManager: EntityManagerProvider,
		private idiomaService: IdiomaService,
		public router: Router,
		private permisosService: PermisosService,
		public sws: ServiciosWebServiceProvider,
		private route: ActivatedRoute,
		private exportador: Exportar) {

		this.breadcrumbService.setItems([
			{
				label: this.translate.instant('Encuestas.Encuestas')
			}
		]);

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';
		this.cols_encuestas = [
			{ field: 'nombreEncuesta', header: this.translate.instant('Encuestas.NombreEncuesta'), visible: true  },
			{ field: 'formulacionPregunta', header: this.translate.instant('Encuestas.Pregunta'), visible: true   },
			{ field: 'formulacionRespuesta', header: this.translate.instant('Encuestas.Respuesta'), visible: true }, // clases: ['th-tipo-medio'] },
			{ field: 'fecha', header: this.translate.instant('Encuestas.Fecha'), visible: true  },
			{ field: 'usuario', header: this.translate.instant('Encuestas.Usuario'), visible: true  },
			{ field: 'tipoPregunta', header: this.translate.instant('Encuestas.Tipo'), visible: false  },
			

		];
		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');
	}

	ngOnInit() {
		const that = this;
		that.entityManager.getIDIOMA()
		.then(function (idiomasENTIDAD: any) {
			that.idiomas = [];
			idiomasENTIDAD.forEach(idioma => {
				if(idioma.Visible === true){
					that.idiomas.push(new Idioma(idioma));
				}
			});

			that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;

			return that.obtenerRespuestas();

		}).then(function () {
			// Ocultamos Spinner
			that.spinner.style.display = 'none';
			return that.comprobarPermisos();
		});



	}

	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
		});
	}

		/* IDIOMA */
		onIdiomaChange($event) {

			// Cambiamos el idioma seleccionado
			let idioma;
			if ($event === undefined) {
				idioma = this.idiomaSeleccionado ? this.idiomaSeleccionado : this.idiomaService.getIdiomaDefecto(this.idiomas);
			}
			else{
				idioma = $event.value;
			}
			if (!idioma) {
				return;
			}
			this.idiomaSeleccionado = idioma;
	

	
			this.obtenerRespuestas();
	
		
		}

		exportarEncuestas(){
			// this.loadContenido(true);
			this.loadEncuestasExportar();
		}

		loadEncuestasExportar() {

			const that = this;
	
			// Mostramos Spinner
			this.spinner.style.display = 'inherit';
			that.exportador.exportarXLS(that.exportador.generarHojaEncuestas(that.encuestasFiltradas), 'Encuestas');
			that.spinner.style.display = 'none';
		}

	
	obtenerRespuestas(){
		const that = this;
			const idEspacio = that.authService.getIdEspacio();
			const token = that.authService.getToken();

		return that.sws.wsObtenerRespuestas(token, idEspacio, that.idiomaSeleccionado.ENTIDAD.Id).toPromise()
		.then(function (respuestas) {
			respuestas = respuestas.lista;
			that.encuestas = [];
			respuestas.forEach(element => {
					const encuesta = new Encuesta().fromENTIDAD(element);
					that.encuestas.push(encuesta);
				});
			that.encuestasFiltradas = that.encuestas;
		})
		.catch(function (e) {
			that.appComponent.showError(e.message);
			return false;
		});

		


	}


	onTipologiaChange(event, dt) {
		this.filtrarTabla(dt, event, 'TIPOLOGIA_BALIZA', 'equals');
	}

	onNivelbateriaChange(event, dt) {
		this.filtrarTabla(dt, event, 'NivelBateria', 'le');
	}

	onFechaChange(dt, event, columna, tipo) {
		// Centralizamos el filtrado
		if (tipo === 'Hasta') {
			if(event){
				event.setHours(23,59,59,0);
			}
		}
		if (tipo === 'Desde') {
			if(event){
				event.setHours(0,0,0,0);
			}
		}

		this.filtrarTabla(dt, event, columna, tipo);
	}

	onFechaAceptar(dt, calendar, columna, tipo) {
		console.log(calendar);
		const fecha = calendar.value ? calendar.value : new Date();
		if (tipo === 'Hasta') {
			fecha.setHours(23,59,59,0);
		}
		if (tipo === 'Desde') {
			fecha.setHours(0,0,0,0);
		}
		this.onFechaChange(dt, fecha, columna, tipo);
		calendar.overlayVisible=false;
	}

	counter(i: number) {
		return new Array(i);
	}

	filtrarTabla(dt, event, columna, tipo){

		const that = this;
		this.encuestasFiltradas = this.encuestas;


		// Preparamos los valores de los filtros
		if (tipo === 'Desde') {
			if (columna === 'fecha') {
				this.fecha_DesdeFilter = event;
			}

		}

		if (tipo === 'Hasta') {
			if (columna === 'fecha') {
				this.fecha_HastaFilter = event;
			}

		}

		// Aplicamos filtro Fecha
		this.encuestasFiltradas = this.encuestasFiltradas.filter(function (bal) {
			console.log(bal)
			let flagDesde = true;
			let flagHasta = true;
			if ((that.fecha_DesdeFilter === undefined || that.fecha_DesdeFilter === null) &&
				(that.fecha_HastaFilter === undefined || that.fecha_HastaFilter === null)) {
				return true;
			}
			if (that.fecha_DesdeFilter !== undefined && that.fecha_DesdeFilter !== null ) {
				flagDesde = that.fecha_DesdeFilter < new Date(bal.fecha);
			}
			if (that.fecha_HastaFilter !== undefined && that.fecha_HastaFilter !== null) {
				flagHasta = that.fecha_HastaFilter > new Date(bal.fecha);
			}
			return flagDesde && flagHasta;
		});



	}



}




// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/Encuestas/Encuestas.component.ts